var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { I18NLink, Translate } from "../../I18N";
import { NeedAuthorization } from "../../Auth";
import { Icon } from "../../UI";
import { PreserveIcon } from "../../Layout/PreserveIcon";
import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import { connect } from 'react-redux';

const SettingsNavigationComponent = ({ allowcustomJS }) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Settings")
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/account", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Account")
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/dashboard", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Dashboard")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/users", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Users & Groups")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/collection", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Collection")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/navlinks", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Menu")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/pages", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Pages")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/languages", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Languages")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/translations", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Translations")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/filters", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Filters configuration")
)
)
)
), /*#__PURE__*/
_jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Metadata")
)
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/templates", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Templates")
)
), /*#__PURE__*/
_jsx(FeatureToggle, { feature: "metadataExtraction.url" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: "settings/metadata_extraction",
  activeclassname: "active",
  className: "list-group-item" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Metadata Extraction")
)
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/thesauri", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Thesauri")
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: "settings/relationship-types",
  activeclassname: "active",
  className: "list-group-item" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Relationship types")
)
)
), /*#__PURE__*/

_jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Tools")
), /*#__PURE__*/
_jsx("div", { className: "list-group" }, void 0, /*#__PURE__*/
_jsx(FeatureToggle, { feature: "preserve.host" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "/settings/preserve", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Preserve"), /*#__PURE__*/
_jsx(PreserveIcon, {})
)
)
), /*#__PURE__*/
_jsx(FeatureToggle, { feature: "newRelationships" }, void 0, /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/newrelmigration",
  activeclassname: "active",
  className: "list-group-item",
  "no-translate": true }, void 0,
"New Relationships Migration"

)
)
), /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(I18NLink, { to: "settings/activitylog", activeclassname: "active", className: "list-group-item" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Activity log")
), /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/customisation",
  activeclassname: "active",
  className: "list-group-item" }, void 0,

allowcustomJS ? /*#__PURE__*/
_jsx(Translate, {}, void 0, "Global CSS & JS") : /*#__PURE__*/

_jsx(Translate, {}, void 0, "Global CSS")

), /*#__PURE__*/
_jsx(I18NLink, {
  to: "/settings/custom-uploads",
  activeclassname: "active",
  className: "list-group-item" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Uploads")
)
), /*#__PURE__*/
_jsx("a", {
  className: "list-group-item",
  href: "https://uwazi.io/page/9852italrtk/support",
  target: "_blank",
  rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Documentation"), " ", /*#__PURE__*/_jsx(Icon, { icon: "external-link-alt" })
)
)
)
)
);


export const mapStateToProps = (state) => ({
  allowcustomJS: Boolean(state.settings.collection.get('allowcustomJS'))
});

export const SettingsNavigation = connect(mapStateToProps)(SettingsNavigationComponent);